import React from 'react';
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadBlackV2.svg";
import PdfIcon from "assets/img/pdfIconFile.png";
import { downloadPdfBuffer, fetchAllPostPromisedData } from '../../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../../common/constant';
import moment from 'moment';
import { getPaymentModeName } from '../../../selectPaymentMode/components/constant';

export const formatDate = date => date ? moment(date).format('YYYY-MM-DD') : "";

const DownloadLedgerReport = ({
    fileName = () => { },
    studentBasicDetails,
    downloading,
    setDownloading
}) => {

    const downloadStudentLedgerPdf = async data => {

        const { studentBasicDetailsDTO, paymentDetailsDtoList, studentFinancialDetailsDTO } = data;
        const currentDate = moment(new Date()).format('DD-MMM-YY');
        const currentTime = moment(new Date()).format('hh:mm A');
        const ledgerIssueDate = moment(new Date()).format('DD/MM/YYYY')

        const templateData = {
            ...data,
            runDate: currentDate,
            runTime: currentTime,
            ledgerIssueDate,
            buAddress: studentBasicDetailsDTO?.businessAreaAddress,

            studentFinancialDetailsDTO: { ...studentFinancialDetailsDTO, status: studentBasicDetails?.programAction },
            
            paymentDetailsDtoList: paymentDetailsDtoList?.map(el => {

                const { receiptDate, checkDate, paymentMode } = el;
                return {
                    ...el,
                    receiptDate: formatDate(receiptDate),
                    checkDate: formatDate(checkDate),
                    paymentMode: paymentMode
                }
            })
        }

        const reqObj = {
            templateName: 'studentLedgerReport',
            getPdf: true,
            templateData
        }

        const resp = await fetchAllPostPromisedData(endpoint.createPdf, reqObj);
        if (resp?.code === 200) {
            const pdfBuffer = resp?.pdfFile?.data;
            downloadPdfBuffer(pdfBuffer, fileName());
        }

    }

    const downloadLedgerReport = async () => {
        try {
            setDownloading(true);
            const { applicationId, psid, bu, courseId, term } = studentBasicDetails;

            const reqObj = {
                applicationId,
                psid,
                courseId,
                businessArea: bu,
                term
            }

            const resp = await fetchAllPostPromisedData(endpoint.paymentCollection.getStudentCourseWiseInformation, reqObj);
            if (resp?.code === 200) await downloadStudentLedgerPdf(resp?.data);

        } catch (err) {
            console.error(err);
        } finally {
            setDownloading(false);
        }
    }
    return (
        <div>
            <img src={PdfIcon} className='icon mr-2' />
            <span className='file-name'>{fileName()}</span>
            <span>.pdf</span>
            <span className='ml-2'>
                {downloading
                    ? <i className="fas fa-spinner fa-spin icon" aria-hidden="true" />
                    : <DownloadIcon className='icon cursor' onClick={downloadLedgerReport} />
                }
            </span>
        </div>
    );
}

export default DownloadLedgerReport;